module.exports = __webpack_public_path__ + "img/rouler_positions_front.290c5c85.png";